"use strict"; 
import { oBase, Ilk, oBool, oColor, oCsv, oDaton, oDatim, oDouble, oFloat, oHomin, oInt16, oInt32, oInt64, oMay, oMemo, oText, oWkd } from "../util/ovars";
import { jsDebug } from "../util/classes";
import { UTL } from "../util/classes";
import { TRANS } from "../util/classes";
import { TABLE, TableObject, TBLSCROLLER, TABLE_Location } from "../util/classes";
import { TABLE_SORT_ROWS_AUX_FUNCTIONS } from "../util/classes";
import { TABLE_FORMAT_COLUMNS_AUX_FUNCTIONS } from "../util/classes";
import { DOM_AUX_FUNCTIONS } from "../util/classes";

import { Elcon } from "../util/classes";
import { DLG } from "../util/classes";
import { GSP } from "../util/classes";
import { CMP } from "../util/cmp";
import { SMART_CMP } from "../util/smart_cmp";
import { Whisper } from "../util/classes";
import { VECTOR, VECTOR_Task, VECTOR_Capsule, VECTOR_Info } from "../util/classes";
import { CdFnCntPayload } from "../util/classes";
import { COMM_LOGIC_TYPE } from "../util/classes";
import { DIALOG500 } from "../util/dialog500";
import { NotifyPlus, NotifyPlusStyleRecord, NotifyPlusAuxFunctions } from "../util/popupPlus_Notify"; // <--- ייבוא הפונקציה הספציפית
import { FacadePlus } from "../util/popupPlus_Facade";



import { NRECT } from "../util/classes";
import { CANVAS } from "../util/CANVAS";

export class spt_test_canvas_container {
    public static hello(): void {
        alert("spt_test_canvas_container.hello()");
    }


    public static drawYellowSquare(ctx: CanvasRenderingContext2D, left: number, top: number): void {

        debugger;
        ctx.fillStyle = 'yellow';
        const r: NRECT = new NRECT();
        r.left = left;
        r.right = left + 250;
        r.top = top;
        r.bottom = top + 150;

        //ctx.fillRect(left, top, 150, 150);
        //ExactPaintRECT(ctx, r: NRECT, color: string): void {
        CANVAS.ExactPaintRECT(ctx, r, "green");
    }
}
